import React, { Suspense } from 'react';
import logo from './logo.svg';
import './App.css';
import Order from './components/Order';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import LicensePromotion1New from './components/licensepromotion1New';
import LicensePromotion from './components/licensepromotion';
import ChangeCCOnline from './components/changeCCOnline';
import MigrationSubscriptionCreate from './components/migrationSubscriptionCreate';

// Error Boundary Component
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h2>Something went wrong loading this page.</h2>
          <p>{this.state.error?.message}</p>
        </div>
      );
    }
    return this.props.children;
  }
}

const MW3Upgrade = React.lazy(() => import('./components/MW3Upgrade'));
const MW3NewViewOrder = React.lazy(() => import('./components/MW3NewViewOrder'));
const MW3NewPurchase = React.lazy(() => import('./components/MW3NewPurchase'));
const UpdateRecurringUserInfo = React.lazy(() => import('./components/UpdateRecurringUserInfo'));
const CancelReason = React.lazy(() => import('./components/CancelReason'));
const CancelReasonMessage = React.lazy(() => import('./components/CancelReasonMessage'));
const UpdateRecurringUserInfoMessage = React.lazy(() => import('./components/UpdateRecurringUserInfoMessage'));

export class App extends React.Component {

  render() {
      return (
        <ErrorBoundary>
        <BrowserRouter> 
          <Suspense fallback={<div></div>}>
          <Routes>
              
              <Route path="/store/SWOneYearNewlicenseOrder.do" element={<Order />}  />
              <Route path="/store/SWNewlicenseOrder.do" element={<Order />}  />
              <Route path="/store/CWNewlicenseOrder.do" element={<Order />}  />
              <Route path="/store/DiscountOneYearCWNewlicenseOrder.do" element={<Order />}  />
              <Route path="/store/DiscountOneYearSWNewlicenseOrder.do" element={<Order />}  />
              <Route path="/store/DiscountTwoYearCWNewlicenseOrder.do" element={<Order />}  />
              <Route path="/store/DiscountTwoYearSWNewlicenseOrder.do" element={<Order />}  />
              <Route path="/store/DiscountRecurringCWNewLicenseOrder.do" element={<Order />}  />
              <Route path="/store/DiscountRecurringSWNewLicenseOrder.do" element={<Order />}  />
              <Route path="/store/Discount1RecurringSWNewLicenseOrder.do" element={<Order />}  />
              <Route path="/store/Discount1RecurringCWNewLicenseOrder.do" element={<Order />}  />
              <Route path="/store/CWOneYearNewlicenseOrder.do" element={<Order />}  />
              <Route path="/store/SWRecurringNewLicenseOrder.do" element={<Order />} />
              <Route path="/store/CWTwoYearNewlicenseOrder.do" element={<Order />} />
              <Route path="/store/SWTwoYearNewlicenseOrder.do" element={<Order />} />
              <Route path="/store/CWRecurringNewLicenseOrder.do" element={<Order />} />
              <Route path="/store/MW3RecurringCWNewLicenseOrder.do" element={<Order />}/>
              <Route path="/store/DiscountSWNewlicenseOrder.do" element={<Order />} />
              <Route path="/store/DiscountCWNewlicenseOrder.do" element={<Order />} />
              <Route path="/store/Discount1SWNewlicenseOrder.do" element={<Order />} />
              <Route path="/store/Discount1CWNewlicenseOrder.do" element={<Order />} />
              <Route path="/store/NewRetailer.do" element={<MW3Upgrade />} />
              <Route path="/store/MW2ToMW3NewUpgrade.do" element={<MW3Upgrade />} />              
              <Route path="/store/MW2ToMW3UpgradeSWNewlicenseOrder.do" element={<Order />} />
              <Route path="/store/MW2ToMW3UpgradeCWNewlicenseOrder.do" element={<Order />} />
              <Route path="/store/NewViewOrder.do" element={<MW3NewViewOrder />}/>
              <Route path="/store/NewPurchase.do" element={<MW3NewPurchase />}/>
              <Route path="/store/UpdateRecurringUserInfo.do" element={<UpdateRecurringUserInfo />}/>
              <Route path="/store/CancelReason.do" element={<CancelReason />}/>
              <Route path="/store/CancelReasonMessage.do" element={<CancelReasonMessage />}/>
              <Route path="/store/UpdateRecurringUserInfoMessage.do" element={<UpdateRecurringUserInfoMessage />}/>
              <Route path="/store/licensepromotion1New.do" element={<LicensePromotion1New />}/>
              <Route path="/store/licensepromotion.do" element={<LicensePromotion />}/>
              <Route path="/store/changeCCOnline.do" element={<ChangeCCOnline />}/>
              {/* <Route path="/store/migrationSubscriptionCreate.do" element={<MigrationSubscriptionCreate />}/> */}
              {/* <Route path="/store/MW3OneYearSWLicense.do" element={<Order />}/> */}
              
          </Routes>
          </Suspense>
        </BrowserRouter>
        </ErrorBoundary>
      );
  }
}

export default App;
